import {
  GET_APP_INFO,
  GET_APP_INFO_FAILED,
  GET_APP_INFO_SUCCESS,
  GET_CURRENCIES,
  GET_CURRENCIES_SUCCESS,
  GET_CURRENCIES_FAIL,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAIL,
  GET_COMM_CHANNELS,
  GET_COMM_CHANNELS_SUCCESS,
  GET_COMM_CHANNELS_FAIL,
  GET_MUNICIPALITIES,
  GET_MUNICIPALITIES_SUCCESS,
  GET_MUNICIPALITIES_FAIL,
} from "./actionTypes"

export const getAppInfo = options => ({
  type: GET_APP_INFO,
  payload: options,
})

export const getAppInfoSuccess = payload => ({
  type: GET_APP_INFO_SUCCESS,
  payload,
})

export const getAppInfoFail = payload => ({
  type: GET_APP_INFO_FAILED,
  payload,
})

// Get Currencies
export const getCurrenciesAction = (options, history) => ({
  type: GET_CURRENCIES,
  payload: { options, history },
})

export const getCurrenciesSuccess = currencies => ({
  type: GET_CURRENCIES_SUCCESS,
  payload: currencies,
})

export const getCurrenciesFail = error => ({
  type: GET_CURRENCIES_FAIL,
  payload: error,
})

// Get Cities
export const getCitiesAction = (options, history) => ({
  type: GET_CITIES,
  payload: { options, history },
})

export const getCitiesSuccess = cities => ({
  type: GET_CITIES_SUCCESS,
  payload: cities,
})

export const getCitiesFail = error => ({
  type: GET_CITIES_FAIL,
  payload: error,
})

// Get Communication Channels
export const getCommChannels = (options, history) => ({
  type: GET_COMM_CHANNELS,
  payload: { options, history },
})

export const getCommChannelsSuccess = commChannels => ({
  type: GET_COMM_CHANNELS_SUCCESS,
  payload: commChannels,
})

export const getCommChannelsFail = error => ({
  type: GET_COMM_CHANNELS_FAIL,
  payload: error,
})

// Get Municipalities
export const getMunicipalitiesAction = (options, history) => ({
  type: GET_MUNICIPALITIES,
  payload: { options, history },
})

export const getMunicipalitiesSuccess = municipalities => ({
  type: GET_MUNICIPALITIES_SUCCESS,
  payload: municipalities,
})

export const getMunicipalitiesFail = error => ({
  type: GET_MUNICIPALITIES_FAIL,
  payload: error,
})
